import axios from 'axios';
import { AuthContextValue } from '@/contexts/auth';
import { API_PREFIX } from '@/constants';
import { SOP, SOPType, SOPStatus } from './constants';

export type SOPListQueryParams = {
  type: SOPType;      //必填  SOP类型
  status?: SOPStatus; //非必填 SOP状态
  current: number;    //必填 当前页
  pageSize: number;   //必填 每页展示的大小
}

export type SOPListResult = {
  data: SOP[];
  current: number;
  pageSize: number;
  total: number;
};

export type SOPCountInfoResult = {
  customerData: {
    pendingCount: number;
    completeCount: number;
  };
  chatData: {
    pendingCount: number;
    completeCount: number;
  };
  pendingTotalCount: number;  // 未完成任务总数
};

export const querySOPList = async (
  { type = SOPType.CHAT_SOP, current = 1, pageSize = 20, status, ...searchParams }: SOPListQueryParams,
  auth: AuthContextValue
) => {
  const { corpId, userId } = auth;
  const res = await axios.get<SOPListResult>(`${API_PREFIX.WEB}/sop/task/list`, {
    params: { userId, corpId, statusType: status, type, current, pageSize, ...searchParams }
  });
  if (res && res.data) {
    const { data = [], ...pagination } = res.data;
    return { data, pagination };
  }
  // return {
  //   data: [
  //     {
  //       id: 1,
  //       sopName: '这里是管理端配置的群SOP名称',
  //       scene: '客户旅程名称-节点名称',
  //       executeTime: '2021-10-09 10:00:00',
  //       sopSendType: SOPSendType.WEEK,
  //       totalAmount: 200,
  //       sendAmount: 13,
  //       messageContent: [
  //         { type: MessageType.TEXT, content: { text: '亲，您浏览这个宝贝许久了，刚好我们今天有一个非常优惠的活动，特松您一份大礼，扫码领取专属优惠，快去下单吧，早早把宝贝买回家。' } },
  //         { type: MessageType.IMAGE, content: { picUrl: 'https://qa-pcrm.shuyun.com/pcrm/202110/e2f5f56627cbabf6e6790fe70503cefe/135426_23548_刮刮乐背景图.jpg' } },
  //         {
  //           type: MessageType.LINK, content: {
  //             desc: '10月特惠合集，打开有大惊喜哟！快来吧。10月特惠合集，打开有大惊喜哟！快来吧。',
  //             picUrl: 'https://qa-pcrm.shuyun.com/pcrm/202110/e2f5f56627cbabf6e6790fe70503cefe/164920_73586_带娃.jpeg',
  //             title: '我是活动内容，不进来看看怎么知道有没有喜欢的？手慢了都让别人抢走啦！我是活动内容，不进来看看怎么知道有没有喜欢的？手慢了都让别人抢走啦！',
  //             url: 'http://www.metaversed.top/'
  //           }
  //         }
  //       ]
  //     },
  //     {
  //       id: 2,
  //       sopName: '这里是管理端配置的群SOP名称',
  //       scene: '客户旅程名称-节点名称',
  //       executeTime: '2021-10-09 10:01:00',
  //       sopSendType: SOPSendType.DAY,
  //       totalAmount: 200,
  //       sendAmount: 23,
  //       messageContent: [
  //         { type: MessageType.TEXT, content: { text: '亲，您浏览这个宝贝许久了，刚好我们今天有一个非常优惠的活动，特松您一份大礼，扫码领取专属优惠，快去下单吧，早早把宝贝买回家。' } },
  //         { type: MessageType.IMAGE, content: { picUrl: 'https://qa-pcrm.shuyun.com/pcrm/202110/e2f5f56627cbabf6e6790fe70503cefe/135426_23548_刮刮乐背景图.jpg' } },
  //         {
  //           type: MessageType.LINK, content: {
  //             desc: '10月特惠合集，打开有大惊喜哟！快来吧。10月特惠合集，打开有大惊喜哟！快来吧。',
  //             picUrl: 'https://qa-pcrm.shuyun.com/pcrm/202110/e2f5f56627cbabf6e6790fe70503cefe/164920_73586_带娃.jpeg',
  //             title: '我是活动内容，不进来看看怎么知道有没有喜欢的？手慢了都让别人抢走啦！我是活动内容，不进来看看怎么知道有没有喜欢的？手慢了都让别人抢走啦！',
  //             url: 'http://www.metaversed.top/'
  //           }
  //         }
  //       ]
  //     },
  //     {
  //       id: 3,
  //       sopName: '这里是管理端配置的群SOP名称33333',
  //       scene: '客户旅程名称-节点名称',
  //       executeTime: '2021-10-09 10:00:00',
  //       sopSendType: SOPSendType.WEEK,
  //       totalAmount: 200,
  //       sendAmount: 33,
  //       messageContent: [
  //         { type: MessageType.TEXT, content: { text: '亲，您浏览这个宝贝许久了，刚好我们今天有一个非常优惠的活动，特松您一份大礼，扫码领取专属优惠，快去下单吧，早早把宝贝买回家。' } },
  //         { type: MessageType.IMAGE, content: { picUrl: 'https://qa-pcrm.shuyun.com/pcrm/202110/e2f5f56627cbabf6e6790fe70503cefe/135426_23548_刮刮乐背景图.jpg' } },
  //         {
  //           type: MessageType.LINK, content: {
  //             desc: '10月特惠合集，打开有大惊喜哟！快来吧。10月特惠合集，打开有大惊喜哟！快来吧。',
  //             picUrl: 'https://qa-pcrm.shuyun.com/pcrm/202110/e2f5f56627cbabf6e6790fe70503cefe/164920_73586_带娃.jpeg',
  //             title: '我是活动内容，不进来看看怎么知道有没有喜欢的？手慢了都让别人抢走啦！我是活动内容，不进来看看怎么知道有没有喜欢的？手慢了都让别人抢走啦！',
  //             url: 'http://www.metaversed.top/'
  //           }
  //         }
  //       ]
  //     },
  //   ] as SOP[],
  //   pagination: {
  //     current: 1,
  //     pageSize: 20,
  //     total: 3
  //   }
  // }
}

export const querySOPCountInfo = async (auth: AuthContextValue) => {
  const { userId, corpId } = auth;
  const res = await axios.get<SOPCountInfoResult>(`${API_PREFIX.WEB}/sop/task/count`, {
    params: { userId, corpId }
  });
  return res.data;
  // return {
  //   customerData: {
  //     pendingCount: 5,
  //     completeCount: 7
  //   },
  //   chatData: {
  //     pendingCount: 33,
  //     completeCount: 15
  //   },
  //   pendingTotalCount: 38
  // }
}
